import * as React from 'react';
import Box from '@mui/material/Box';
import ComingSoon from "../Upcomingpages/ComingSoon";

class OPConfiguration extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <ComingSoon></ComingSoon>
        )
    }

}

export default OPConfiguration;